import { $curSandTableId, $tourDataApi } from '@stores/dataStores';
import { $editingMapMarkerApi } from '@stores/editingMarkerStores';
import {
  type STImage,
  type STMap,
  STMapMarkerType,
  type STMatrix,
} from '@types';
import type { Draft } from 'immer';

export const onMapMarkerMoveEnd = ({
  id,
  lat,
  lng,
}: {
  id: string;
  lng: number;
  lat: number;
}) => {
  const mapId = $curSandTableId.getState();
  if (!mapId) return;
  $tourDataApi.updateSandtable({
    id: mapId,
    updater: (draft: Draft<STMap>) => {
      const marker = draft.markers.find((x) => x.id === id);
      if (!marker) return;
      switch (marker.type) {
        case undefined:
        case STMapMarkerType.scene:
        case STMapMarkerType.point:
        case STMapMarkerType.text:
        case STMapMarkerType.image: {
          marker.icon.lat = lat;
          marker.icon.lng = lng;
          break;
        }
      }
    },
  });
  $editingMapMarkerApi.move({ id, lat, lng });
};

export const onImageMarkerMoveEnd = ({
  id,
  atv,
  ath,
}: {
  id: string;
  ath: number;
  atv: number;
}) => {
  const mapId = $curSandTableId.getState();
  if (!mapId) return;
  $tourDataApi.updateSandtable({
    id: mapId,
    updater: (draft: Draft<STImage | STMatrix>) => {
      const marker = draft.markers.find((x) => x.id === id);
      if (marker) {
        marker.icon.atv = atv;
        marker.icon.ath = ath;
      }
    },
  });
};
